export { default } from './GraphQLDoc'